//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { copyrightInfoApi } from '@/api/authInformation';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  name: 'i-copyright',
  data: function data() {
    return {
      links: [{
        title: '官网',
        key: '1',
        href: '',
        blankTarget: true
      }, {
        title: '社区',
        key: '2',
        href: '',
        blankTarget: true
      }, {
        title: '文档',
        key: '3',
        href: '',
        blankTarget: true
      }],
      copyright: '',
      copyrightNew: ''
    };
  },
  mounted: function mounted() {
    if (checkPermi(['platform:copyright:get:info'])) this.getVersion();
  },
  methods: {
    getVersion: function getVersion() {
      copyrightInfoApi().then(function (res) {
        console.log(res);
        var data = res || {};
        // this.copyrightNew = data.companyName ? data.companyName : this.copyright;
      });
    }
  }
};